/* section-message-action.tsx generated by @compiled/babel-plugin v0.36.0 */
import "./section-message-action.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import React, { memo } from 'react';
import Button from '@atlaskit/button/standard-button';
import { cx } from '@atlaskit/css';
import { fg } from '@atlaskit/platform-feature-flags';
import { Anchor, Box, Pressable } from '@atlaskit/primitives';
var styles = {
  common: "_11c81oud _syaz14q2 _k48p1wq8 _30l314q2 _9h8h16c2",
  anchor: "_1053w7te _9oik18uv _1bnx8stv _jf4cnqa1 _n0fxw7te _1vhvg3x0",
  pressable: "_bfhksm61 _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _9oik18uv _1bnx8stv _jf4cnqa1"
};

/**
 * __Section message action__
 *
 * A section message action is designed to work with the `action` prop from
 * `SectionMessage`. It renders either a button or a link depending on whether
 * an `onClick` or `href` prop is supplied, with a dot separator in between actions.
 *
 * - [Examples](https://atlassian.design/components/section-message/examples#actions)
 */
var SectionMessageAction = /*#__PURE__*/memo(function SectionMessageAction(_ref) {
  var children = _ref.children,
    onClick = _ref.onClick,
    href = _ref.href,
    testId = _ref.testId,
    linkComponent = _ref.linkComponent;
  if (!linkComponent && fg('platform_section_message_action_migration')) {
    if (href) {
      return /*#__PURE__*/React.createElement(Anchor, {
        testId: testId,
        onClick: onClick,
        href: href,
        xcss: cx(styles.common, styles.anchor)
      }, children);
    }
    if (onClick) {
      return /*#__PURE__*/React.createElement(Pressable, {
        testId: testId,
        onClick: onClick,
        xcss: cx(styles.common, styles.pressable)
      }, children);
    }
    return /*#__PURE__*/React.createElement(Box, {
      as: "span",
      testId: testId
    }, children);
  }
  return onClick || href ? /*#__PURE__*/React.createElement(Button, {
    testId: testId,
    appearance: "link",
    spacing: "none",
    onClick: onClick,
    href: href,
    component: href ? linkComponent : undefined
  }, children) : /*#__PURE__*/React.createElement(React.Fragment, null, children);
});
export default SectionMessageAction;